import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@libs/types/src/common/object-type/ok.object';
import {
    KrzpDoctorCreateInput,
} from '@libs/types/src/services/input-type/services/krzp-doctor.create-input';
import {
    KrzpDoctorUpdateInput,
} from '@libs/types/src/services/input-type/services/krzp-doctor.update-input';
import {
    KrzpDoctorGridObject, KrzpDoctorObject,
} from '@libs/types/src/services/object-type/service/krzp-doctor.object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { filterFrag } from './types/filter.types';

@Injectable({ providedIn: 'root' })
export class KrzpDoctorGqlService extends GqlServiceV2 {
    public getKrzpDoctors(input: GridInput, fragment: string): Promise<KrzpDoctorGridObject> {
        return this.query<KrzpDoctorGridObject>(`
            query($input: GridInput!) {
                krzpDoctor {
                    filter(input: $input) {
                        ${filterFrag}
                        items { ${fragment} }
                    }
                }
            }
        `, { input });
    }

    public createKrzpDoctor(input: KrzpDoctorCreateInput): Promise<KrzpDoctorObject> {
        return this.mutate<KrzpDoctorObject>(`
            mutation($input: KrzpDoctorCreateInput!) {
                krzpDoctor { create(input: $input) { id } }
            }
        `, { input });
    }

    public updateKrzpDoctor(input: KrzpDoctorUpdateInput): Promise<KrzpDoctorObject> {
        return this.mutate<KrzpDoctorObject>(`
            mutation($input: KrzpDoctorUpdateInput!) {
                krzpDoctor { update(input: $input) { id } }
            }
        `, { input });
    }

    public deleteKrzpDoctor(input: IdInput): Promise<OkObject> {
        return this.mutate<OkObject>(`
            mutation($input: IdInput!) {
                krzpDoctor { delete(input: $input) { ok } }
            }
        `, { input });
    }
}
